var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.pageHeaderActionsConfig,
          "left-side-class": "col-xl-5",
          page: {
            icon: "fas fa-user-circle",
            title: "Manejo de Reembolso y Pago Directo",
            routes: [
              "Inicio",
              "Estudiante",
              "Manejo de Reembolso y Pago Directo"
            ]
          },
          "right-side-class":
            "col-xl-7 align-items-end d-flex pb-3 justify-content-end"
        }
      }),
      _vm.toggleStatusCard
        ? _c("card-status-transition", {
            attrs: {
              role: _vm.currentUserRole,
              statuses: _vm.availableStatuses,
              title: "Cambiar estatus de la factura"
            },
            on: {
              "on-close": function($event) {
                _vm.toggleStatusCard = false
              },
              "on-continue": _vm.onSwitchStatus
            }
          })
        : _vm._e(),
      _vm.showStatusCardReadonly
        ? _c("card-status-readonly", {
            attrs: {
              comment: this.infoData.statusComment,
              title: this.infoData.statusName
            }
          })
        : _vm._e(),
      _vm.toggleAdjustmentCard
        ? _c("create-adjustment", {
            on: {
              "on-close": function($event) {
                _vm.toggleAdjustmentCard = false
              },
              "on-save": function($event) {
                return _vm.onSaveAdjustmentHandler($event)
              }
            }
          })
        : _vm._e(),
      _c("board", {
        staticClass: "mb-4",
        attrs: { details: _vm.detailsBoard }
      }),
      _c(
        "custom-tab",
        {
          key: "f",
          staticClass: "custom-nav-container custom-nav-colors font-18",
          attrs: {
            "content-class": "mt-3 pb-5 font-18",
            "nav-class": "font-18",
            "no-nav-style": true
          }
        },
        [
          _c(
            "custom-tab-item",
            {
              staticClass: "mt-3",
              attrs: {
                active: _vm.currentIndexTab == _vm.detailsInfoTabs.Resumen,
                lazy: "",
                title: "Resumen"
              },
              on: {
                click: function($event) {
                  return _vm.onActiveTab(_vm.detailsInfoTabs.Resumen)
                }
              }
            },
            [
              _vm.infoData
                ? _c("reinbursement-resume", {
                    key: _vm.resumeKey,
                    ref: "reinbursementResumeRef",
                    attrs: {
                      id: "reinbursement-resume-provider",
                      data: _vm.infoData,
                      "is-read-only": _vm.isReadOnly,
                      "proposal-documents": _vm.infoData.proposalDocuments
                    },
                    on: {
                      "on-amount-change": _vm.updateAmount,
                      "on-check-period": _vm.updatePeriods,
                      "on-comment-change": _vm.updateComment,
                      "refresh-data": _vm.onRefreshData
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          !_vm.isNewStatus
            ? _c(
                "custom-tab-item",
                {
                  staticClass: "mt-3",
                  attrs: {
                    active:
                      _vm.currentIndexTab == _vm.detailsInfoTabs.Historial,
                    lazy: "",
                    title: "Historial"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onActiveTab(_vm.detailsInfoTabs.Historial)
                    }
                  }
                },
                [
                  _c("tracking-history", {
                    attrs: { "request-id": _vm.requestId }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.canShowAdjustments
            ? _c(
                "custom-tab-item",
                {
                  staticClass: "mt-3",
                  attrs: {
                    active: _vm.currentIndexTab == _vm.detailsInfoTabs.Ajustes,
                    lazy: "",
                    title: "Ajustes"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onActiveTab(_vm.detailsInfoTabs.Ajustes)
                    }
                  }
                },
                [
                  _c("adjustment-history", {
                    ref: "adjustmentHistoryRef",
                    attrs: { data: _vm.infoData },
                    on: {
                      "on-delete-adjustment": function($event) {
                        return _vm.onDeleteAdjustmentHandler($event)
                      },
                      "on-edit-adjustment": function($event) {
                        return _vm.onEditAdjustmentHandler($event)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.canShowPayments
            ? _c(
                "custom-tab-item",
                {
                  staticClass: "mt-3",
                  attrs: {
                    active: _vm.currentIndexTab == _vm.detailsInfoTabs.Pagos,
                    lazy: "",
                    title: "Pagos"
                  },
                  on: { click: () => _vm.showPaymentTab() }
                },
                [
                  _c("payment-view", {
                    ref: "paymentViewRef",
                    attrs: {
                      "academic-year-id": _vm.infoData.academicYearId,
                      "can-manually-set-voucher-id":
                        _vm.canManuallySetVoucherId,
                      "determination-id": _vm.infoData.determinationId,
                      "disbursement-amount": _vm.infoData.amountToRefund,
                      "disbursement-info": _vm.paymentInfo,
                      "disbursement-status": _vm.infoData.statusId,
                      documents: _vm.infoData.documents,
                      "payment-model": _vm.infoData.paymentId,
                      "request-id": _vm.infoData.requestId,
                      "tap-request-id": _vm.infoData.tapRequestId,
                      year: _vm.infoData.year
                    },
                    on: {
                      "update:disbursementInfo": function($event) {
                        _vm.paymentInfo = $event
                      },
                      "update:disbursement-info": function($event) {
                        _vm.paymentInfo = $event
                      },
                      "delete-digit": function($event) {
                        return _vm.deleteBillingDigit($event)
                      },
                      "on-update-po": _vm.onUpdateVoucherStatusHandler,
                      saveDigit: function($event) {
                        return _vm.saveDisbursementDigits()
                      }
                    },
                    model: {
                      value: _vm.payment,
                      callback: function($$v) {
                        _vm.payment = $$v
                      },
                      expression: "payment"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }